import script from "./InputBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./InputBanner.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__